// Module
var code = "<div class=\"player-olympic-tips\">Is already the last one</div>";
// Exports
module.exports = code;